import React from 'react';
import InputCounter from '../../InputCounter/InputCounter';

type EditorInputCounterProps = {
  maxLength: number | 0; // without HTML, i.e. stripped tags
  currentCount: number;
  children: React.ReactNode;
};

export default function EditorInputCounter({ maxLength, currentCount, children }: EditorInputCounterProps) {
  return (
    <>
      {children}
      {maxLength > 0 && <InputCounter currentCount={currentCount} maxLength={maxLength} modifier="visible" />}
    </>
  );
}
